import * as CryptoJS from "crypto-js";
import { saltCode } from "@utils/Constants";

export const encryptData = (data: string) =>
  CryptoJS.AES.encrypt(data, saltCode).toString();

export const decryptData = (data: string) =>
  CryptoJS.AES.decrypt(data, saltCode).toString(CryptoJS.enc.Utf8);
